import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAirflow = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_1",
		d: "m0.44536,23.74044l11.38207,-11.66713c0.03513,-0.03471 0.05693,-0.08068 0.06157,-0.12986c0.00466,-0.04916 -0.00815,-0.0984 -0.03615,-0.13908c-0.69212,-0.9663 -1.96928,-1.13389 -2.44266,-1.7832c-1.402,-1.92325 -1.75776,-3.01206 -2.36031,-2.94449c-0.04205,0.00605 -0.0807,0.02646 -0.10943,0.05776l-4.11154,4.21486c-2.36555,2.42282 -2.70546,7.76323 -2.76685,12.23527c-0.00019,0.04447 0.01292,0.08805 0.03768,0.12503c0.02477,0.03684 0.06002,0.06559 0.10124,0.08236c0.04122,0.01677 0.08652,0.02081 0.13005,0.01168c0.04354,-0.00928 0.08342,-0.03115 0.11433,-0.06319z",
		fill: "#017CEE"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_2",
		d: "m23.73869,23.45219l-11.66709,-11.3828c-0.03473,-0.03523 -0.08077,-0.0571 -0.13002,-0.06175c-0.04927,-0.00466 -0.09859,0.00821 -0.1393,0.03631c-0.9663,0.69251 -1.13387,1.96928 -1.7832,2.44266c-1.92324,1.40197 -3.01206,1.75776 -2.94448,2.36032c0.00614,0.04193 0.02652,0.08041 0.05774,0.10901l4.21486,4.11146c2.42282,2.36562 7.76312,2.70554 12.23516,2.76693c0.04432,0 0.0876,-0.01318 0.12444,-0.03773c0.03669,-0.02471 0.06529,-0.05975 0.08206,-0.10078c0.01677,-0.04103 0.02096,-0.08595 0.01198,-0.12938c-0.00883,-0.04343 -0.03055,-0.08326 -0.06214,-0.11425z",
		fill: "#00AD46"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_3",
		d: "m11.34799,21.06755c-1.32447,-1.29212 -1.93821,-3.84821 0.60006,-9.1191c-4.12651,1.84416 -5.57246,4.26821 -4.86137,4.96226l4.26131,4.15683z",
		fill: "#04D659"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_4",
		d: "m23.45044,0.15823l-11.38165,11.66713c-0.0352,0.03467 -0.05707,0.08064 -0.06171,0.12983c-0.00466,0.04919 0.00819,0.09846 0.03627,0.13911c0.69251,0.9663 1.96891,1.13387 2.44266,1.7832c1.40202,1.92318 1.7581,3.0121 2.36037,2.94442c0.04208,-0.00599 0.08071,-0.02635 0.10931,-0.05765l4.11161,-4.21489c2.36547,-2.42282 2.70539,-7.76317 2.76678,-12.23521c0.00015,-0.0445 -0.01303,-0.088 -0.03788,-0.12494c-0.02486,-0.03694 -0.06005,-0.06562 -0.10138,-0.08237c-0.04118,-0.01674 -0.0864,-0.0208 -0.12998,-0.01163s-0.08341,0.03106 -0.1144,0.06301z",
		fill: "#00C7D4"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_5",
		d: "m21.06954,12.54931c-1.29212,1.32447 -3.84821,1.93823 -9.11943,-0.60005c1.84416,4.1265 4.26824,5.5724 4.96229,4.86143l4.15713,-4.26138z",
		fill: "#11E1EE"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_6",
		d: "m0.15662,0.44614l11.66713,11.38168c0.03471,0.03514 0.08068,0.05693 0.12984,0.06159c0.04918,0.00466 0.09841,-0.00815 0.1391,-0.03615c0.9663,-0.69251 1.13387,-1.96928 1.7832,-2.44266c1.92319,-1.40202 3.01212,-1.75776 2.94443,-2.36031c-0.00614,-0.04202 -0.0265,-0.08064 -0.05765,-0.10943l-4.2149,-4.11154c-2.42282,-2.36555 -7.76317,-2.70546 -12.23521,-2.76685c-0.04459,-0.00028 -0.08824,0.0128 -0.1253,0.03759c-0.03708,0.02477 -0.06586,0.06009 -0.08264,0.10141c-0.01679,0.0413 -0.0208,0.0867 -0.01152,0.13031c0.00928,0.04362 0.03137,0.08348 0.06352,0.11437z",
		fill: "#E43921"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_7",
		d: "m12.54971,2.82976c1.32447,1.29217 1.93821,3.84817 -0.60006,9.11946c4.12645,-1.84416 5.57251,-4.26857 4.86138,-4.96225l-4.26132,-4.15721z",
		fill: "#FF7557"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_8",
		d: "m2.82897,11.34931c1.29218,-1.32447 3.84818,-1.93821 9.11947,0.60006c-1.84418,-4.12651 -4.26821,-5.57246 -4.96226,-4.86137l-4.15721,4.26131z",
		fill: "#0CB6FF"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "null",
		id: "svg_9",
		d: "m11.95019,12.45614c0.28101,0 0.50879,-0.2278 0.50879,-0.50879c0,-0.28099 -0.22779,-0.50878 -0.50879,-0.50878c-0.28099,0 -0.50878,0.22779 -0.50878,0.50878s0.22779,0.50879 0.50878,0.50879z",
		fill: "#4A4848"
	}));
});
export default SvgAirflow;
